import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { DirectionService } from "../../core/service/direction.service";
import { Direction } from "../../core/model/direction";

@Component({
  selector: "app-edit-direction",
  templateUrl: "./edit-direction.component.html",
  styleUrls: ["./edit-direction.component.scss"],
})
export class EditDirectionComponent implements OnInit {
  @Input()
  set direction(value: Direction) {
    if (value) {
      this._direction = { ...value };
      this.loading = false;
      this.cdr.detectChanges();
    }
  }
  get direction(): Direction {
    return this._direction;
  }

  private _direction!: Direction;

  form2!: FormGroup;
  pressButton: Boolean = false;
  loading = true;

  constructor(
    private _directionService: DirectionService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._directionService
      .putDirection(this.direction)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.direction);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
